/** The accent tinting a chip's fill and glyph; omit for the neutral chip. */
export type IconChipAccent = 'blue' | 'violet' | 'teal' | 'green' | 'orange' | 'red'

/** Chip diameter: `xs` for an inline marker, `sm` for a list bullet, `md` for a section medallion. */
export type IconChipSize = 'xs' | 'sm' | 'md'

/** The single source for accent → fill/glyph classes; reuse this instead of re-deriving it. */
export const ICON_CHIP_ACCENT_CLASSES: Record<IconChipAccent | 'neutral', string> = {
  neutral: 'bg-bg-tertiary text-icon-secondary',
  blue: 'bg-accent-blue-soft text-accent-blue',
  violet: 'bg-accent-violet-soft text-accent-violet',
  teal: 'bg-accent-teal-soft text-accent-teal',
  green: 'bg-accent-green-soft text-accent-green',
  orange: 'bg-accent-orange-soft text-accent-orange',
  red: 'bg-accent-red-soft text-accent-red',
}

/** The outlined chip: the accent as an inset ring and glyph over no fill, for a marker that ends a path. */
export const ICON_CHIP_OUTLINE_CLASSES: Record<IconChipAccent | 'neutral', string> = {
  neutral: 'text-icon-primary inset-ring-2 inset-ring-border-strong',
  blue: 'text-accent-blue inset-ring-2 inset-ring-accent-blue',
  violet: 'text-accent-violet inset-ring-2 inset-ring-accent-violet',
  teal: 'text-accent-teal inset-ring-2 inset-ring-accent-teal',
  green: 'text-accent-green inset-ring-2 inset-ring-accent-green',
  orange: 'text-accent-orange inset-ring-2 inset-ring-accent-orange',
  red: 'text-accent-red inset-ring-2 inset-ring-accent-red',
}

/** The selected chip: a solid accent fill with the on-accent glyph, for the picked item. */
export const ICON_CHIP_SELECTED_CLASSES: Record<IconChipAccent | 'neutral', string> = {
  neutral: 'bg-bg-inverted text-bg-primary',
  blue: 'bg-accent-blue text-text-on-accent',
  violet: 'bg-accent-violet text-text-on-accent',
  teal: 'bg-accent-teal text-text-on-accent',
  green: 'bg-accent-green text-text-on-accent',
  orange: 'bg-accent-orange text-text-on-accent',
  red: 'bg-accent-red text-text-on-accent',
}

/** Chip outline: `tile` is a squircle tile, `disc` a circle. */
export type IconChipShape = 'tile' | 'disc'
